import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';

const LandingModalCloseIcon = styled(CloseIcon)`
  font-size: 28px;
  color: #A2AAB3;
  cursor: pointer;

  @media only screen and (min-width: 960px) {
    margin-right: -10px;
  }
`;

export default LandingModalCloseIcon;
